<template>
  <DsFeaturesSection
    title-base="Características"
    title-highlight="generales"
    title-id="estrena2-features-title"
    :features="features"
  />
</template>

<script setup lang="ts">
import assuredWorkloadIcon from '../../../../../assets/estrena2/assured_workload_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 1.svg'
import folderCopyIcon from '../../../../../assets/estrena2/folder_copy_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 1.svg'
import homeIcon from '../../../../../assets/estrena2/Vector.svg'
import paymentsIcon from '../../../../../assets/estrena2/payments_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 1.svg'
import realEstateAgentIcon from '../../../../../assets/estrena2/Vector (1).svg'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const features = [
  {
    id: 'housing-type',
    iconSrc: homeIcon,
    title: 'Tipo de vivienda',
    description: 'Vivienda de uso'
  },
  {
    id: 'buyer',
    iconSrc: realEstateAgentIcon,
    title: 'Comprador',
    description: 'Persona física'
  },
  {
    id: 'financial-validation',
    iconSrc: paymentsIcon,
    title: 'Validación financiera',
    description: 'Revisión de capacidad de pago'
  },
  {
    id: 'file',
    iconSrc: folderCopyIcon,
    title: 'Expediente',
    description: 'Integración documental obligatoria'
  },
  {
    id: 'initial-flexibility',
    iconSrc: assuredWorkloadIcon,
    title: 'Flexibilidad inicial',
    description: 'Posibilidad de un periodo previo antes de pagos completo'
  }
]
</script>
